import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import vueSeamlessScroll from 'vue-seamless-scroll';
export default {
  name: 'shopRank',
  props: {
    rankData: Array
  },
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      // rankData:[],
      classOption: {
        step: 0.3,
        waitTime: 500,
        autoPlay: false,
        switchDelay: 1000,
        singleHeight: 46,
        hoverStop: true,
        limitMoveNum: 10,
        singleHeight: 0,
        // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0,
        openWatch: true,
        direction: 1
      },
      rankIndex: {
        1: 'diyi',
        2: 'dierming',
        3: 'disanming'
      },
      timer: null,
      //这里加个key值来刷新 滚动 从第一个开始
      num: Math.random(0, 1000)
    };
  },
  computed: {
    max() {
      if (this.rankData.length === 0) return 0;
      return this.rankData[0].value;
    }
  },
  methods: {
    filterValue(val) {
      if (!val || this.max === 0) {
        return 0;
      }
      return parseInt(val / this.max * 100);
    },
    // 移入
    mouseOver(e) {
      const path = e.path || e.composedPath && e.composedPath();
      let target = path.filter(r => /shop-item/.test(r.className));
      this.rankData.map(item => {
        item.show = false;
      });
      if (target.length != 0) {
        this.num = Math.random() * 100;
        this.rankData[Number(target[0].id) - 1].show = true;
      }
    },
    // 移出
    mouseLeave(e) {
      console.log(e, 66);
      this.rankData.map(item => {
        item.show = false;
      });
      this.num = Math.random() * 100;
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  watch: {
    rankData2: {
      handler(nl, ol) {
        // this.rankData=this.rankData2;
        this.classOption.autoPlay = false;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.num = Math.random() * 100;
        console.log(666, this.num);
        this.timer = setTimeout(() => {
          this.classOption.autoPlay = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, 2000);
      },
      deep: true
    }
  }
};